import React from 'react';
import TeamIcon from 'src/assets/icons/team_icon_in_circle.svg';
import EmailIcon from 'src/assets/icons/email_icon_in_circle.svg';
import styles from '../index.css';
import { Heading, FlexBox, Span, Paragraph } from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

const Waitlist = () => {
	return (
		<FlexBox className={styles.SetupCardLayout}>
			<Heading {...theme.heading.setUpTitle}>You're on the Waitlist for Wisely!</Heading>
			<FlexBox alignItems="center">
				<TeamIcon
					style={{ verticalAlign: 'middle', marginRight: '15px', marginBottom: '5px' }}
				/>
				<Paragraph>
					There are <Span color={theme.colors.lightBlue}> less than 100</Span> people
					ahead of you!
					<br />
					Don't despair - we're processing your data as quickly as possible <br /> and
					will be in touch soon!
				</Paragraph>
			</FlexBox>
			<FlexBox alignItems="center">
				<EmailIcon
					style={{ verticalAlign: 'middle', marginRight: '15px', marginBottom: '5px' }}
				/>
				<Paragraph>
					In the meantime, feel free to click away from this page. <br />
					We'll send you an email once everything is ready.
				</Paragraph>
			</FlexBox>
		</FlexBox>
	);
};

export default Waitlist;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Setup/Waitlist/index.js